/*!

=========================================================
* Paper Dashboard React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import { Route, Switch } from "react-router-dom";

import Navbar from "components/Navbars/Navbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import NhanVien from "pages/Staff"
import CapNhap from "pages/Update"
import Plugin from "pages/Plugin"
import Dll from "pages/Dll"
import UserReport from "pages/UserReport"
import AdminReport from "pages/AdminReport"
import NgonNgu from "pages/Languages"
import ServerStatus from "pages/ServerStatus";
import Deco from "../security/decrypt"
import Tools from "pages/Tools"
import DownloadFile from "pages/SharedFiles"
import ToolDetails from "features/Tools/ToolDetails"
import Resources from "pages/Resources"
import SocketManager from "pages/SocketManager"
import ChatManager from "pages/ChatManager"
import { ToolProvider } from "contexts/ToolContext"
import { PageProvider } from "contexts/PageContext"

import routes from "routes.js";

var ps;

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      backgroundColor: "black",
      activeColor: "info",
      newRoutes: []
    };
    this.mainPanel = React.createRef();
  }
  componentDidMount() {
    // if (navigator.platform.indexOf("Win") > -1) {
    //   ps = new PerfectScrollbar(this.mainPanel.current);
    //   document.body.classList.toggle("perfect-scrollbar-on");
    // }
    this.logged()
    this.administratorPrivileges()
    // this.getToolFromServer()
  }
  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
      document.body.classList.toggle("perfect-scrollbar-on");
    }
  }
  componentDidUpdate(e) {
    if (e.history.action === "PUSH") {
      this.mainPanel.current.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
    }
  }

  administratorPrivileges() {
    const user = JSON.parse(Deco(localStorage.getItem('user')));
    if (user.role == "ADMIN") {
      routes.push({
        path: "/staff",
        name: "Staff",
        icon: "nc-icon nc-badge",
        component: NhanVien,
        layout: "/admin",
      })

      // Gắn cờ divider: true
      routes.push({
        divider: true,
        path: "/divider",
        name: "divider",
        layout: "/admin",
      });
    }

    routes.push({
      path: "/dashboard",
      name: "Server Status",
      icon: "nc-icon nc-atom",
      component: ServerStatus,
      layout: "/admin",
      exact: true
    })

    routes.push({
      path: "/socket-manager",
      name: "Socket Manager",
      icon: "nc-icon nc-vector",
      component: SocketManager,
      layout: "/admin",
    })

    routes.push({
      path: "/chat-manager",
      name: "Chat Manager",
      icon: "nc-icon nc-chat-33",
      component: ChatManager,
      layout: "/admin",
    })

    // Route cho chi tiết tools - không hiển thị trong sidebar
    routes.push({
      path: "/tools/:matool",
      component: ToolDetails,
      layout: "/admin",
      hidden: true
    })

    routes.push({
      path: "/tools",
      name: "Tool Management",
      icon: "nc-icon nc-app",
      component: Tools,
      layout: "/admin",
      exact: true
    })

    routes.push({
      path: "/language",
      name: "Language",
      icon: "nc-icon nc-planet",
      component: NgonNgu,
      layout: "/admin",
    })

    // Gắn cờ divider: true
    routes.push({
      divider: true,
      path: "/divider",
      name: "divider",
      layout: "/admin",
    });

    routes.push({
      path: "/update",
      name: "Update",
      icon: "nc-icon nc-cloud-upload-94",
      component: CapNhap,
      layout: "/admin",
    })

    routes.push({
      path: "/plugin",
      name: "Plugin",
      icon: "nc-icon nc-app",
      component: Plugin,
      layout: "/admin",
    })

    routes.push({
      path: "/dll",
      name: "Dll",
      icon: "nc-icon nc-app",
      component: Dll,
      layout: "/admin",
    })

    routes.push({
      path: "/resources",
      name: "Resource",
      icon: "nc-icon nc-box-2",
      component: Resources,
      layout: "/admin",
    })

    // Gắn cờ divider: true
    routes.push({
      divider: true,
      path: "/divider",
      name: "divider",
      layout: "/admin",
    });

    routes.push({
      path: "/shared-files",
      name: "Shared File",
      icon: "nc-icon nc-cloud-download-93",
      component: DownloadFile,
      layout: "/admin",
    })

    // Gắn cờ divider: true
    routes.push({
      divider: true,
      path: "/divider",
      name: "divider",
      layout: "/admin",
    });

    routes.push({
      path: "/user-reports",
      name: "User Report",
      icon: "nc-icon nc-settings",
      component: UserReport,
      layout: "/admin",
    })

    routes.push({
      path: "/admin-reports",
      name: "Admin Report",
      icon: "nc-icon nc-settings",
      component: AdminReport,
      layout: "/admin",
    })


    // routes.push({
    //   path: "/download",
    //   name: "Download",
    //   icon: "nc-icon nc-box",
    //   component: CapNhap,
    //   layout: "/admin",
    // })

    this.setState({ newRoutes: routes })
  }

  logged() {
    try {
      const user = JSON.parse(Deco(localStorage.getItem('user')));
      if (user == '') {
        window.location = "/admin/login"
        return
      }

      var dateNow = new Date();
      var decodedToken = parseJwt(user.token)



      if (decodedToken.exp < dateNow.getTime() / 1000) {
        window.location = "/admin/login"
        return
      }

    } catch (error) {
      window.location = "/admin/login"
      return
    }

    function parseJwt(token) {
      var base64Url = token.split('.')[1];
      var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));

      return JSON.parse(jsonPayload);
    };
  }

  getTool() {
    const queryPath = window.location.pathname;
    return queryPath.replace(/admin/gi, '').replace(/[^a-zA-Z0-9 ]/g, '')
  }

  getBrand(arr) {
    let brandName = ''
    arr.map((prop) => {
      if (window.location.href.indexOf(prop.layout + prop.path) !== -1) {
        brandName = prop.name;
      }
      return null;
    });
    return brandName
  }

  render() {
    const { newRoutes } = this.state
    return (
      <PageProvider>
        <ToolProvider>
          <div className="wrapper">
            <Sidebar
              {...this.props}
              routes={newRoutes.filter(route => !route.hidden)}
              bgColor={this.state.backgroundColor}
              activeColor={this.state.activeColor}
            />
            <div className="main-panel" ref={this.mainPanel}>
              <Navbar title={this.getBrand(newRoutes)} {...this.props} />
              <Switch>  {
                newRoutes.map((prop, key) => {
                  return (
                    <Route
                      path={prop.layout + prop.path}
                      component={prop.component}
                      key={key}
                      exact={prop.exact}
                    />
                  );
                })
              }</Switch>
              {/* <Footer fluid /> */}
            </div>
          </div>
        </ToolProvider>
      </PageProvider>
    );
  }
}

export default Dashboard;
